<template>
  <AppLayout>

    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <h6 class="">Witaj, {{ $page.props.user.first_name ?? '' }} {{ $page.props.user.last_name ?? '' }}</h6>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="item in localNews" :key="item.id" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
        <div class="news-card h-100" @click="openModal(item)">
          <span class="badge mb-2" :class="badgeClass(item.type)">{{ typeLabel(item.type) }}</span>
          <h5 class="news-title">{{ item.title }}</h5>
          <div class="news-description">
            {{ shortDescription(item.description) }}
          </div>
          <div class="news-footer mt-2 d-flex justify-content-between align-items-center">
            <div v-if="isAdmin">
              <small>
                <strong v-if="item.type == 2 || item.type == 3" class="ms-4"><i class="bi bi-person-add"></i>&nbsp;{{
                  item.yes_count }}</strong>
                <strong v-if="item.type == 3" class="ms-4"><i class="bi bi-person"></i>&nbsp;{{ item.yes2_count
                }}</strong>
                <strong v-if="item.type == 2 || item.type == 3" class="ms-4"><i class="bi bi-person-dash"></i>&nbsp;{{
                  item.no_count }}</strong>
              </small>
            </div>
            <div>
              <small>
                <i>Dodano: {{ formatDate(item.created_at) }}</i>
              </small>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedNews" class="custom-modal-backdrop">
      <div class="custom-modal">
        <div class="modal-header-custom">
          <div>
            <span class="badge" :class="badgeClass(selectedNews.type)">{{ typeLabel(selectedNews.type) }}</span>
            <h4 class="mt-2">{{ selectedNews.title }}</h4>
            <div v-if="selectedNews.user_status !== null" class="mt-2">
              Twój wybór: <b>{{ userStatusLabel(selectedNews.user_status) }}</b>
            </div>
          </div>
          <button class="close-btn" @click="closeModal">✕</button>
        </div>
        <div class="modal-body-custom">
          <div v-html="selectedNews.description"></div>
        </div>
        <div class="modal-footer-custom">
          <!-- TYPE 1 -->
          <template v-if="selectedNews.type === 1">
            <button class="btn btn-success ms-2 mb-2" :disabled="selectedNews.user_status === 1" @click="respond(1)">OK
              / zapoznałem się</button>
            <button class="btn btn-secondary ms-2 mb-2" @click="closeModal">Zamknij</button>
          </template>

          <!-- TYPE 2 -->
          <template v-if="selectedNews.type === 2">
            <button class="btn btn-success ms-2 mb-2" :disabled="selectedNews.user_status === 1"
              @click="respond(1)">Wezmę udział</button>
            <button class="btn btn-warning ms-2 mb-2" :disabled="selectedNews.user_status === 0" @click="respond(0)">Nie
              wezmę udziału</button>
            <button class="btn btn-danger ms-2 mb-2" :disabled="selectedNews.user_status === 2" @click="respond(2)">Nie
              pokazuj więcej</button>
          </template>

          <!-- TYPE 3 -->
          <template v-if="selectedNews.type === 3">
            <button class="btn btn-outline-success ms-2 mb-2" :disabled="selectedNews.user_status === 1"
              @click="respond(1)">Tak + osoba towarzysząca</button>
            <button class="btn btn-outline-success ms-2 mb-2" :disabled="selectedNews.user_status === 3"
              @click="respond(3)">Tak, przyjdę sam/a</button>
            <button class="btn btn-danger ms-2 mb-2" :disabled="selectedNews.user_status === 0" @click="respond(0)">Nie
              wezmę udziału</button>
          </template>

        </div>
      </div>
    </div>

    <div v-if="zadaniaKanban.length" class="row mb-4">
      <div class="col-12">
        <div class="widget widget-six">
          <div class="widget-heading d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              <i class="bi bi-kanban me-2"></i>
              Twoje zadania
            </h6>

            <span class="badge bg-primary">
              {{ zadaniaKanban.length }} zadań
            </span>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Zadanie</th>
                  <th>Tablica</th>
                  <th>Status</th>
                  <th>Priorytet</th>
                  <th>Postęp</th>
                  <th>Termin</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="zadanie in zadaniaKanban" :key="zadanie.id">
                  <td>
                    <a v-if="zadanie.tablica_id" :href="`/kanban/boards-all/${zadanie.tablica_id}`"
                      class="task-title-link" :title="`Przejdź do tablicy: ${zadanie.tablica || ''}`">
                      <strong>{{ zadanie.title }}</strong>
                    </a>
                    <strong v-else>{{ zadanie.title }}</strong>
                    <div v-if="zadanie.description" class="text-muted small mt-1">
                      {{ zadanie.description.replace(/<[^>]*>/g, '').slice(0, 100) }}
                    </div>
                  </td>

                  <td>
                    {{ zadanie.tablica || '—' }}
                  </td>

                  <td>
                    <span class="badge bg-secondary">
                      {{ zadanie.kolumna || '—' }}
                    </span>
                  </td>

                  <td>
                    {{ zadanie.priority || 'Normalny' }}
                  </td>

                  <td style="min-width: 120px">
                    <div class="progress" style="height: 8px">
                      <div class="progress-bar" role="progressbar" :style="{
                        width: Math.min(100, Math.max(0, Number(zadanie.percent) || 0)) + '%'
                      }" :aria-valuenow="zadanie.percent || 0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>

                    <small class="text-muted">
                      {{ zadanie.percent || 0 }}%
                    </small>
                  </td>

                  <td>
                    <span v-if="zadanie.due_at" :class="{
                      'text-danger':
                        zadanie.due_at.slice(0, 10) <
                        new Date().toISOString().slice(0, 10)
                    }">
                      {{ formatDate(zadanie.due_at) }}
                    </span>

                    <span v-else class="text-muted">Brak terminu</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="hasPermission('canViewKadry') && hasPermission('canViewWorkersDane') && urlopyZmiany.length"
      class="row mb-4">
      <div class="col-12">
        <div class="widget widget-six">
          <div class="widget-heading d-flex justify-content-between align-items-center">
            <h6 class="mb-0">
              Zmiany w wymiarze urlopu — {{ rokUrlopu }}
            </h6>

            <span class="badge bg-warning text-dark">
              {{ urlopyZmiany.length }} zmian
            </span>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Pracownik</th>
                  <th>Dotychczas</th>
                  <th>Po przeliczeniu</th>
                  <th>Zmiana</th>
                  <th>Staż</th>
                  <th>Wykształcenie</th>
                  <th>Podstawa</th>
                  <th>Dni w roku</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in urlopyZmiany" :key="item.user_id">
                  <td>
                    <a :href="`/kadry/show/user/${item.user_id}`" class="text-primary hover:underline cursor-pointer">
                      <strong>{{ item.pracownik }}</strong>
                    </a>
                  </td>

                  <td>
                    {{ item.poprzednio }} dni
                  </td>

                  <td>
                    <strong>{{ item.ten_rok }} dni</strong>
                  </td>

                  <td>
                    <span class="badge" :class="item.roznica > 0 ? 'bg-success' : 'bg-danger'">
                      {{ item.roznica > 0 ? '+' : '' }}{{ item.roznica }} dni
                    </span>
                  </td>

                  <td>
                    {{ item.staz }} lat
                  </td>

                  <td>
                    {{ item.wyksztalcenie }}
                  </td>

                  <td>
                    {{ item.podstawa }} dni
                  </td>

                  <td>
                    {{ item.dni_w_roku }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "../Layouts/App.vue"
import axios from "axios"
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasRole, hasPermission } = usePermission();

export default {
  components: { AppLayout, hasRole, hasPermission, },

  props: {
    news: {
      type: Array,
      default: () => []
    },
    zadaniaKanban: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectedNews: null,
      localNews: [...this.news],
      urlopyZmiany: [],
      rokUrlopu: null,
      hasPermission
    }
  },
  mounted() {
    this.pobierzZmianyUrlopow();
  },
  methods: {
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('pl-PL') : ''
    },
    async pobierzZmianyUrlopow() {
      try {
        const response = await axios.get('/check-urlopy', {
          params: {
            json: 1
          }
        });

        this.rokUrlopu = response.data.rok;
        this.urlopyZmiany = response.data.wyniki || [];

      } catch (e) {
        console.error('Błąd podczas pobierania zmian urlopowych:', e);
        this.urlopyZmiany = [];
      }
    },

    shortDescription(html) {
      if (!html) return '';

      const text = html.replace(/<[^>]*>/g, '');

      return text.length > 120
        ? text.substring(0, 120) + '...'
        : text;
    },

    isAdmin() {
      return hasRole('ADMIN');
    },
    userStatusLabel(status) {
      return {
        0: 'Nie',
        1: 'Tak',
        3: 'Tak, sam',
        2: 'Nie pokazuj więcej'
      }[status] || 'Brak'
    },
    openModal(item) {
      this.selectedNews = item
    },

    closeModal() {
      this.selectedNews = null
    },
    async respond(status) {

      try {

        if (status === 2) {

          const result = await Toast.fire({
            toast: false,
            icon: 'warning',
            title: 'Ukrycie komunikatu',
            html: 'Czy na pewno nie chcesz już widzieć tej informacji?',
            showDenyButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Tak',
            denyButtonText: 'Nie',
            timer: false,
            position: 'center'
          });

          if (!result.isConfirmed) {
            return;
          }
        }

        await axios.post('/news/respond', {
          news_id: this.selectedNews.id,
          status: status
        });

        this.selectedNews.user_status = status;
        if (status === 1 || status === 3) {
          this.successMsg('Dziękujemy za potwierdzenie udziału, twoja informacja została zapisana.');
        }
        if (
          (status === 2) ||
          (status === 1 && this.selectedNews.type !== 3) ||
          (status === 0 && this.selectedNews.type === 3)
        ) {
          this.localNews = this.localNews.filter(
            n => n.id !== this.selectedNews.id
          );
        }

        this.closeModal();

      } catch (e) {
        console.error(e);
      }
    },

    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('pl-PL') : ''
    },

    typeLabel(type) {
      return {
        1: 'Informacja',
        2: 'Ogłoszenie',
        3: 'Komunikat'
      }[type] || 'Komunikat'
    },

    badgeClass(type) {
      return {
        1: 'bg-primary',
        2: 'bg-info',
        3: 'bg-success'
      }[type] || 'bg-secondary'
    },
    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
}
</script>
<style scoped>
.news-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  cursor: pointer;
  transition: 0.2s;
  border: 1px solid #ececec;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.news-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.08);
}

.news-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #222;
}

.news-description {
  color: #666;
  font-size: 14px;
  min-height: 60px;
  line-height: 1.5;
}

.news-footer {
  border-top: 1px solid #f1f1f1;
  padding-top: 10px;
  color: #999;
}

.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;
}

.custom-modal {
  width: 100%;
  max-width: 700px;

  background: white;
  border-radius: 18px;

  overflow: hidden;
  animation: modalShow 0.2s ease;
}

@keyframes modalShow {

  from {
    transform: scale(0.95);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-header-custom {
  padding: 25px;
  border-bottom: 1px solid #eee;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modal-body-custom {
  padding: 25px;
  max-height: 500px;
  overflow-y: auto;
  white-space: pre-line;
}

.modal-footer-custom {
  padding: 20px 25px;
  border-top: 1px solid #eee;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
}

.news-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.table th {
  font-size: 13px;
  white-space: nowrap;
}

.table td {
  font-size: 14px;
}

.table-responsive {
  border-radius: 10px;
}

.task-title-link {
  color: #0d6efd;
  text-decoration: none;
  cursor: pointer;
}

.task-title-link:hover {
  text-decoration: underline;
  color: #0a58ca;
}
</style>